import Vue from 'vue'
import VueRouter from 'vue-router'
import Deal from '../views/Deal.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/:id',
        name: 'Deal',
        component: Deal
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
